
export class AiSame {
countItemsByCategory: {[key: string]: number};
listItemsByCategory: {[key: string]: string[]};
nbCount: number;
nbRequired: number;
requiredItemsByCategory: {[key: string]: number};
score: number | null;
}

